import styled from 'styled-components';

import Accordion from '../../../../../../../components/Accordion';
import { Title } from '../../../../../../../components/Accordion/styles';
import { Container, ReadyPreview, SessionVideo } from '../../../../../../../components/SessionVideoUpload/styles';
import colors from '../../../../../../../styles/colors';

/* White, so the row stands out on the grey product card, and flush with what follows it. */
const Panel = styled(Accordion)`
  && {
    background-color: ${colors.base.alpha};
    margin: 16px 0 0;
  }
`;

/* The tags and the line give way on a narrow card; the label keeps to one line. */
const Heading = styled(Title)`
  flex-shrink: 0;
  white-space: nowrap;
`;

const Summary = styled.span`
  font-size: 13px;
  color: ${colors.shades.gamma10};
`;

/* The long-session panel's layout, without the side padding the workout editor's form needs. */
const Section = styled(Container)`
  padding: 0;
  gap: 8px;
`;

const LivePreview = styled(ReadyPreview)`
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
`;

/*
  Fits in a 320px square: a portrait video sits beside its details at 180px wide instead of running
  down the card, and a landscape one keeps the long-session panel's 320px.
*/
const LiveVideo = styled(SessionVideo)`
  flex-shrink: 0;
  width: min(100%, 320px, calc(320px * ${({ $aspectRatio }) => $aspectRatio}));
`;

const LiveDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export {
  Panel,
  Heading,
  Summary,
  Section,
  LivePreview,
  LiveVideo,
  LiveDetails,
};
